module.exports = __webpack_public_path__ + "img/ico_haeder02.f0f49d9.svg";